import {createModal} from "../modal";

$(document).on('click', '.time_confirmed', async function () {
    let booking_slot_id = $(this).attr('data-booking-slot-id');
    console.log("booking_slot_id")
    console.log(booking_slot_id)
    const booking = await getBookedBy(booking_slot_id);
    console.log(booking)

    const content =  `
<div class="grid grid-cols-12 dark:text-gray-100">
    <div class="col-span-5">Booked by</div>
    <div class="col-span-7">${booking.user.first_name}</div>
    <div class="col-span-5">Location</div>
    <div class="col-span-7">${booking.court.location.name}</div>
    <div class="col-span-5">Court</div>
    <div class="col-span-7">${booking.court.name}</div>
    <div class="col-span-5">Time</div>
    <div class="col-span-7">${moment('2020-01-01 '+booking.start_time).format("HH:mm")} - ${moment('2020-01-01 '+booking.end_time).format("HH:mm")}</div>
</div>`
    createModal(content, 'Booking Information', 'w-96')

})

// Attach to the global scope
window.createModal = createModal;

const getBookedBy = async (booking_slot_id) => {
    try {
        const response        = await fetch(`/api/booking/show`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:            true,
                booking_slot_id: booking_slot_id,
            })
        });
        return await response.json()

    } catch (error) {
        console.log(error)
    }
}
